import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Accordion from '../../../../../components/Accordion/Accordion';
import { isMobile } from 'react-device-detect';
import FormLabel from '@material-ui/core/FormLabel';
import { useSearchParams } from 'hooks/useSearchParams';
import { Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDriversList } from 'useStores/useDriversStore';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const UsersSearch = () => {
  const classes = useStyles();
  const { register, handleSubmit } = useForm();
  const [params, setParams, deleteParams] = useSearchParams();
  const setTotalPages = useDriversList((state) => state.setTotalPages);

  function handleClickSearch(data) {
    setParams([{ name: 'page', value: 1 }]);
    const filters = Object.entries(data);
    filters.map((item) =>
      item[1] === ''
        ? deleteParams([{ name: item[0] }])
        : setParams([{ name: item[0], value: item[1] }])
    );
  }

  return (
    <div className={classes.root}>
      <Accordion open title="فیلترهای جستجو">
        <form onSubmit={handleSubmit(handleClickSearch)}>
          <div className={classes.filters}>
            <TextField
              defaultValue={params.get('firstName') || ''}
              {...register('firstName')}
              name="firstName"
              variant="outlined"
              label="نام"
              size="small"
              fullWidth
            />
            <TextField
              {...register('lastName')}
              name="lastName"
              defaultValue={params.get('lastName') || ''}
              variant="outlined"
              label="نام خانوادگی"
              size="small"
              fullWidth
            />
            <TextField
              {...register('nationalCode')}
              name="nationalCode"
              defaultValue={params.get('nationalCode') || ''}
              variant="outlined"
              label="کدملی"
              size="small"
              fullWidth
              type="number"
            />
            <TextField
              {...register('mobilePhone')}
              name="mobilePhone"
              defaultValue={params.get('mobilePhone') || ''}
              variant="outlined"
              label="موبایل"
              size="small"
              fullWidth
              type="number"
            />
            <TextField
              {...register('smartcard')}
              name="smartcard"
              defaultValue={params.get('smartcard') || ''}
              variant="outlined"
              label="کدناوگان"
              size="small"
              fullWidth
              type="number"
            />
            <div>
              <FormLabel>وضعیت</FormLabel>
              <Switch
                {...register('status')}
                defaultChecked={
                  params.get('status') === null
                    ? true
                    : params.get('status') === 'true'
                }
                name="status"
              />
            </div>
            <Button variant="contained" color="secondary" type="submit">
              جستجو
            </Button>
          </div>
        </form>
      </Accordion>
    </div>
  );
};

export default React.memo(UsersSearch);
